import { useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import { useNavigate } from "react-router-dom";

// ✅ 用來取得本地時區的 datetime-local 格式
function getLocalDateTimeString() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

function BloodPressureForm() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("訪客");
  const [form, setForm] = useState({
    systolic: '',
    diastolic: '',
    heartRate: '',
    notes: '',
    recordedAt: getLocalDateTimeString(), // ✅ 改用本地時間
  });

  useEffect(() => {
    document.title = "新增血壓紀錄";

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.name) {
        setUserName(user.name);
      }
    } catch (err) {
      console.error("讀取 user 發生錯誤", err);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value === "" ? null : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');
    if (!token) return alert('請先登入');

    const payload = {
      ...form,
      heartRate:
        form.heartRate === "" || form.heartRate === undefined
          ? null
          : parseInt(form.heartRate),
      systolic: parseInt(form.systolic),
      diastolic: parseInt(form.diastolic)
    };

    const response = await axios.post('/api/BloodPressure', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });


    if (response.status === 200) {
      alert('新增成功');
      navigate("/blood-pressure/history");
    } else {
      alert('新增失敗');
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3">新增血壓紀錄 - {userName}</h2>

      <div className="mb-3">
        <button
          className="btn btn-success me-2"
          onClick={() => navigate("/blood-pressure/history")}
        >
          血壓歷史記錄
        </button>
        <button
          className="btn btn-outline-secondary"
          onClick={() => navigate("/dashboard")}
        >
          回到目錄
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">收縮壓</label>
          <input
            type="tel"
            inputMode="numeric"
            className="form-control"
            name="systolic"
            value={form.systolic}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">舒張壓</label>
          <input
            type="tel"
            inputMode="numeric"
            className="form-control"
            name="diastolic"
            value={form.diastolic}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">心跳</label>
          <input
            type="tel"
            inputMode="numeric"
            className="form-control"
            name="heartRate"
            value={form.heartRate}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">備註</label>
          <input
            type="text"
            className="form-control"
            name="notes"
            value={form.notes}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">紀錄時間</label>
          <input
            type="datetime-local"
            className="form-control"
            name="recordedAt"
            value={form.recordedAt}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary">送出</button>
      </form>
    </div>
  );
}

export default BloodPressureForm;
